// extracted by mini-css-extract-plugin
export default {"header":"Header_Business_header__eZwsm","logo":"Header_Business_logo__lUGih","nav":"Header_Business_nav__9Ld7f","button":"Header_Business_button__MBiSV"};